import * as React from 'react';

var _circle, _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgLinea = function SvgLinea(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _circle || (_circle = /*#__PURE__*/ React.createElement("circle", {
        cx: 60,
        cy: 60,
        r: 60,
        fill: "#000"
    })), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M79.421 89.994h-49.6V39.742h11.348v40.513H79.42v9.739M79.421 49.476c5.591 0 10.124-4.359 10.124-9.734 0-5.376-4.533-9.734-10.124-9.734s-10.123 4.358-10.123 9.734c0 5.375 4.532 9.734 10.123 9.734"
    })));
};

export { SvgLinea as ReactComponent };
//# sourceMappingURL=Linea.svg.es.js.map
